import React from "react"
import { Formik, Form as FormikForm, Field } from "formik"
import { Row } from "react-bootstrap"
import * as Yup from "yup"
import FormTextbox from "../../shared/formTextbox"
import FormFieldDisableAutoComplete from "../../shared/formFieldDisableAutoComplete"
import FormDatePickerTextBox from "../../shared/formDatePickerTextBox"
import FormDateInputTextbox from "../../shared/formDateInputTextbox"
import FormTimeTextBox from "../../shared/formTimeTextBox"
import FormSectionTitle from "../../shared/formSectionTitle"
import FormAmountTextBox from "../../shared/formAmountTextBox"
import FormDropdownList from "../../shared/formDropdownList"
import FormDropdownMulti from "../../shared/formDropdownMulti"
import { isBefore, parse, format, isValid } from "date-fns"

// import FormDropdownList from "../../shared/formDropdownList"
import FormEditUpload from "../../shared/formEditUpload"

import {
  controlEditBenefit,
  updateValidBenfitFormData,
  updateClickedNext,
  updateFormIsValid,
  pageIncrement,
  completeBenefitForm,
} from "../../../redux/actions"
import * as Constants from "../../../common/constants"
import * as Regex from "../../../common/regex"
import * as ErrorMessage from "../../../common/errorMessage"
import * as CommonFunction from "../../../common/function"
import * as Alert from "../../../services/sweetalertService"

import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"

const DisablementForm = ({ coverageDetail }) => {
  // const formName = Constants.disablementFormName
  const dispatch = useDispatch()
  const formRef = React.useRef()

  const {
    editBenefits,
    allProofDocuments,
    claimUploadListModel,
    clickedNext,
    isComeWithChildCoverage,
    tempBenefitInfo,
    disablementList,
    pageNumber,
    chosenedBenefits,
  } = useSelector(state => state.uiData)

  const claimData = useSelector(state => state.claimData)

  const {
    Category: coverageCategory,
    CoverageCode: coverageCode,
    CoverageDetailId: coverageDetailId,
    CoverageDetailName: coverageDetailName,
  } = coverageDetail

  const formName = coverageCode

  //dropdown data
  const { DisablementAccidentDesc } = useSelector(state => state.dropdownData)

  useSelector(state => {
    if (!state.claimData[coverageCategory][coverageCode]) {
      state.claimData[coverageCategory][coverageCode] = {}
    }
  }, shallowEqual)

  const validationSchema = Yup.object().shape({
    occurrenceDate: Yup.date().required(ErrorMessage.DisablementAccidentDate),
    // .test(
    //   "occurrenceDate",
    //   ErrorMessage.DisablementAccidentDate52WeeksErrorMsg,
    //   value => {
    //     return CommonFunction.notWeeksEarlier(
    //       formRef.current.values.occurrenceDate,
    //       52
    //     )
    //   }
    // ),

    occurrenceTime: Yup.string()
      .required(ErrorMessage.DisablementAccidentTime)
      .matches(Regex.timepattern, ErrorMessage.DisablementAccidentTime)
      .test("occurrenceTime", ErrorMessage.futureTimeErrorMsg, value => {
        return CommonFunction.notFutureDatime(
          formRef.current.values.occurrenceDate,
          value
        )
      }),

    occurrenceNature: Yup.string().required(
      ErrorMessage.DisablementAccidentNature
    ),

    disablementNature: Yup.string().required(ErrorMessage.DisablementNature),

    disablementDescription: Yup.string().required(
      ErrorMessage.DisablementDescription
    ),

    victimName: Yup.string()
      .required(ErrorMessage.disabledVictimName)
      .matches(Regex.namepattern, ErrorMessage.disabledVictimName),

    // victimBirthDate: Yup.date().required(ErrorMessage.birthDate),
    victimBirthDate: Yup.string()
      .required(ErrorMessage.birthDate)
      .length(10, ErrorMessage.birthDate)
      .test("victimBirthDate", ErrorMessage.birthDate, value => {
        const inputDate = parse(
          value,
          `d${Constants.sep}M${Constants.sep}yyyy`,
          new Date()
        )
        const todayDate = parse(
          format(new Date(), "dd/MM/yyyy"),
          `d${Constants.sep}M${Constants.sep}yyyy`,
          new Date()
        )
        return isBefore(inputDate, todayDate) && isValid(inputDate)
      }),

    victimNRIC: Yup.string()
      .required(ErrorMessage.disabledVictimNric)
      .matches(Regex.nricpattern, ErrorMessage.disabledVictimNric),

    // claimAmount: Yup.string()
    //   .transform(value => (isNaN(value) ? undefined : value))
    //   .min(1, ErrorMessage.claimAmount),
  })

  React.useEffect(() => {
    let desc
    if (DisablementAccidentDesc && coverageDetailName) {
      desc = DisablementAccidentDesc.filter(x => {
        return coverageDetailName.includes(x.Description)
      })

      if (desc.length > 0)
        formRef.current.setFieldValue(
          "occurrenceDescription",
          desc[0].Description
        )
    }
  }, [])

  return (
    <Formik
      initialValues={Object.assign(
        {
          occurrenceDate: "",
          occurrenceTime: "",
          occurrenceNature: "",
          disablementNature: "",
          occurrenceDescription: "",
          disablementDescription: "",
          victimName: "",
          victimBirthDate: "",
          victimNRIC: "",
          // claimAmount: 0,
        },
        claimData[coverageCategory][coverageCode]
      )}
      enableReinitialize={true}
      validationSchema={validationSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {}}
    >
      {({ values }) => (
        <>
          <FormikForm>
            {
              <Row
                className={
                  "form-group " + (editBenefits[coverageCode] ? "" : "hide")
                }
              >
                <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                  <p>{coverageDetailName}</p>
                </div>
                <div className="col-md-3 col-5 marginTop10px">
                  <div
                    className="cursorPointer"
                    role="button"
                    tabIndex="0"
                    onClick={() => dispatch(controlEditBenefit(coverageCode))}
                  >
                    <p className="doneEdit">DONE EDIT</p>
                  </div>
                </div>
              </Row>
            }
            {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
            <Field
              textDesc={"Disable Auto Complete"}
              name="disableAutoComplete"
              component={FormFieldDisableAutoComplete}
            />
            <Field
              textDesc={"Date of Accident"}
              name="occurrenceDate"
              component={FormDatePickerTextBox}
            />

            <Field
              textDesc="Time of Accident (HH:mm)"
              name="occurrenceTime"
              component={FormTimeTextBox}
            />

            <Field
              textDesc={"Nature of Accident"}
              maxLength={200}
              name="occurrenceNature"
              component={FormTextbox}
            />

            <Field
              textDesc={"Nature of Disablement"}
              maxLength={200}
              name="disablementNature"
              component={FormTextbox}
            />

            {/* <Field
              textDesc="Description of Accident"
              maxLength={3000}
              name="occurrenceDescription"
              component={FormTextbox}
            /> */}
            <Field
              textDesc="Description of Disability"
              name="occurrenceDescription"
              component={FormDropdownList}
              dropdownItem={DisablementAccidentDesc}
            />

            <FormSectionTitle text={"Disabled Details"} />

            <Field
              textDesc="Name of Disabled"
              maxLength={100}
              name="victimName"
              component={FormTextbox}
            />
            <Field
              textDesc={"Date of Birth"}
              name="victimBirthDate"
              component={FormDateInputTextbox}
            />
            <Field
              textDesc={"Disabled NRIC"}
              maxLength={9}
              name="victimNRIC"
              component={FormTextbox}
              toUpperCase={true}
            />

            <Field
              textDesc="Description of Disablement"
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              name="disablementDescription"
              component={FormDropdownMulti}
              dropdownItem={disablementList}
            />

            {/* <Field
                textDesc={"Amount Claimed(SGD)"}
                maxLength={14}
                name="claimAmount"
                component={FormAmountTextBox}
              /> */}

            <FormEditUpload
              pageTo={Constants.benefitRequiredDocumentPageNumber}
              editBenefits={editBenefits[coverageCode]}
              coverageDetailId={coverageDetailId}
              coverageDetailName={coverageDetailName}
              allProofDocuments={allProofDocuments}
              claimUploadListModel={claimUploadListModel}
            />

            <HandleFormValidation
              thisPageClickedNext={clickedNext[Constants.benefitFormPageNumber]}
              reviewPageClickedNext={clickedNext[Constants.reviewPageNumber]}
              formRef={formRef}
              values={values}
              thisPageNumber={Constants.benefitFormPageNumber}
              dispatch={dispatch}
              formName={formName}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              tempBenefitInfo={tempBenefitInfo}
              chosenedBenefits={chosenedBenefits}
            />
            {/* <HandleClaimAmountUpdate
              claimAmount={values.claimAmount}
              dispatch={dispatch}
              pageNumber={pageNumber}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              formRef={formRef}
            /> */}
          </FormikForm>
        </>
      )}
    </Formik>
  )
}

const HandleFormValidation = ({
  thisPageClickedNext,
  reviewPageClickedNext,
  formRef,
  values,
  thisPageNumber,
  dispatch,
  formName,
  coverageCategory,
  coverageCode,
  tempBenefitInfo,
  chosenedBenefits,
}) => {
  React.useEffect(() => {
    if (
      (thisPageClickedNext && coverageCode === tempBenefitInfo.CoverageCode) ||
      (reviewPageClickedNext &&
        CommonFunction.checkBenefitChosened(chosenedBenefits, coverageCode))
    ) {
      formRef.current.validateForm().then(errors => {
        //console.log(errors)

        batch(() => {
          if (Object.entries(errors).length === 0) {
            // console.log("PASS")

            dispatch(
              updateValidBenfitFormData(coverageCategory, coverageCode, values)
            )
            if (thisPageClickedNext) {
              dispatch(pageIncrement())
              dispatch(completeBenefitForm(coverageCode))
            } else {
              dispatch(updateFormIsValid(formName, true))
            }
          } else {
            if (thisPageClickedNext) {
              Alert.missingInfoAlert()
            } else {
              dispatch(updateFormIsValid(formName, false))
            }
            formRef.current.submitForm() // Set touched to all fields
          }

          dispatch(updateClickedNext(thisPageNumber, false))
        })
      })
    }
  }, [values, thisPageClickedNext, reviewPageClickedNext])
  return null
}

// const HandleClaimAmountUpdate = ({
//   claimAmount,
//   dispatch,
//   pageNumber,
//   coverageCategory,
//   coverageCode,
//   formRef,
// }) => {
//   React.useEffect(() => {
//     if (pageNumber === Constants.reviewPageNumber) {
//       setTimeout(() => {
//       batch(() => {
//         dispatch(
//           updateValidBenfitFormData(
//             coverageCategory,
//             coverageCode,
//             formRef.current.values
//           )
//         )
//       })
//       }, 1000);
//     }
//   }, [claimAmount])

//   return null
// }

export default DisablementForm
